var map = {
	"./11-kg-icon.svg": 2150,
	"./15-kg-icon.svg": 2483,
	"./45-kg-icon.svg": 7276,
	"./5-kg-icon.svg": 7121,
	"./alert.svg": 484,
	"./arrow-back.svg": 7077,
	"./arrow-right.svg": 2009,
	"./arrow-small-right.svg": 6841,
	"./banknotes.svg": 5329,
	"./building.svg": 8771,
	"./cancel.svg": 2392,
	"./check-circle.svg": 1986,
	"./check.svg": 8018,
	"./chevron-left.svg": 5617,
	"./chevron-right.svg": 1070,
	"./circle.svg": 5340,
	"./clock.svg": 993,
	"./close.svg": 8790,
	"./dash.svg": 3032,
	"./delete.svg": 7219,
	"./down-arrow.svg": 3009,
	"./envelope.svg": 1637,
	"./error-circle.svg": 378,
	"./home.svg": 2474,
	"./info.svg": 3669,
	"./loading.svg": 5789,
	"./menu.svg": 6451,
	"./oval.svg": 4947,
	"./question-mark-circle.svg": 8299,
	"./timer-flash-line.svg": 768,
	"./truck.svg": 6985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3739;